import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const SearchSelectedIcon = props => (
    <SvgIcon {...props} viewBox="0 0 15 16">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.40508 10.7463L12.9406 15.3963L14.7 13.7746L10.0546 9.01589C10.7271 7.88516 10.9698 6.54039 10.7363 5.23809C10.5029 3.93578 9.80965 2.76708 8.78883 1.95488C7.76801 1.14269 6.49105 0.743834 5.20152 0.83441C3.91199 0.924987 2.70014 1.49865 1.79709 2.44598C0.89405 3.39331 0.363013 4.64801 0.305274 5.97076C0.247535 7.29352 0.667143 8.59177 1.48405 9.61788C2.30095 10.644 3.45799 11.3262 4.73447 11.5343C6.01096 11.7424 7.31757 11.4619 8.40508 10.7463ZM5.6027 10.5463C7.99552 10.5463 9.93529 8.60651 9.93529 6.21369C9.93529 3.82087 7.99552 1.8811 5.6027 1.8811C3.20988 1.8811 1.27011 3.82087 1.27011 6.21369C1.27011 8.60651 3.20988 10.5463 5.6027 10.5463Z"
        />
        <circle cx="5.63298" cy="6.2101" r="3.13588" />
    </SvgIcon>
);

export default SearchSelectedIcon;
